var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const getCurrentPosition = () => __async(void 0, null, function* () {
  let retry = 0;
  let position = null;
  while (!position || retry < 3 && position.coords.accuracy > 100) {
    position = yield new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 1e4,
        maximumAge: 6e4
      });
    });
    retry++;
  }
  return position;
});
export default getCurrentPosition;
